import React, { useContext, type ReactNode } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { createUseEntryPointContext } from '@atlassian/jira-entry-point/src/controllers/utils/create-use-entry-point-context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { conditionalFormattingSidebarEntryPoint } from '../../entrypoint.tsx';

type ConditionalFormattingEntryPointProviderProps = {
	children: ReactNode;
};

const ConditionalFormattingEntryPointContext =
	createUseEntryPointContext<typeof conditionalFormattingSidebarEntryPoint>();

export const ConditionalFormattingEntrypointProvider = ({
	children,
}: ConditionalFormattingEntryPointProviderProps) => {
	const entryPointProps = {
		message: 'Hello world!',
	};
	const createObjectEntryPoint = useEntryPoint(
		conditionalFormattingSidebarEntryPoint,
		entryPointProps,
	);

	return (
		<ConditionalFormattingEntryPointContext.Provider value={createObjectEntryPoint}>
			{children}
		</ConditionalFormattingEntryPointContext.Provider>
	);
};

export const MaybeConditionalFormattingEntryPointProvider = componentWithCondition(
	() => fg('conditional-formatting-new-list-targeting-gate'),
	ConditionalFormattingEntrypointProvider,
	({ children }: ConditionalFormattingEntryPointProviderProps) => <>{children}</>,
);

export const useConditionalFormattingEntryPoint = () =>
	useContext(ConditionalFormattingEntryPointContext);
